import React from 'react';
import { FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormItem from '../../../../common/forms/FormItem';
import TextInput from '../../../../common/forms/input/TextInput';
import { isRequired } from '../../../../../utils/validators';
import Select from '../../../../common/forms/select/Select';
import FormFooter from '../../../../common/forms/FormFooter';
import { BAGGAGE_MANIFEST_ACTIONS } from '../../../../../config/constants';
import { WRITE } from '../../../../../config/permissions';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { BAGGAGE_ADMINISTRATOR_MOVEMENT_ENDPOINT } from '../../../../../config/endpoints';

const BaggageManifestBoardingSection = ({ saveButtonDisabled }) => (
  <>
    <FormGroup row>
      <FormItem label="Acción" required>
        <Field
          name="action"
          component={Select}
          options={[BAGGAGE_MANIFEST_ACTIONS.DISMISS]}
          validate={[isRequired]}
          value={BAGGAGE_MANIFEST_ACTIONS.DISMISS.value}
          isDisabled
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Comentario" required>
        <Field
          name="comment"
          component={TextInput}
          type="textarea"
          placeholder="Comentario"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter saveButtonDisabled={saveButtonDisabled} />
  </>
);

BaggageManifestBoardingSection.propTypes = {
  saveButtonDisabled: PropTypes.bool.isRequired,
  // eslint-disable-next-line
  isManifestPrinted: PropTypes.bool.isRequired,
};

export default withEndpointAuthorization({
  url: BAGGAGE_ADMINISTRATOR_MOVEMENT_ENDPOINT,
  permissionType: WRITE,
  showForAllWhen: (props) => !props.isManifestPrinted,
})(BaggageManifestBoardingSection);
